module.exports = __webpack_public_path__ + "img/megan-reynolds.923cacf9.jpg";